import { SpotIdSchema as o, DomainNameSchema as e } from "@hprofits/shared";
import { z as n } from "zod";
import { PaginationSchema as a, paginatedList as i } from "../common/pagination.js";
const p = a.extend({
  prefix: n.string().trim().min(3).optional()
}).readonly(), t = n.object({
  id: o,
  name: n.string(),
  impressions: n.int().nonnegative()
}).readonly(), m = n.object({
  domain: e,
  impressions: n.int().nonnegative(),
  spots: n.array(t).readonly()
}).readonly(), d = i(m);
export {
  m as DomainItemSchema,
  p as DomainsQuerySchema,
  d as DomainsResponseSchema,
  t as SpotSchema
};
//# sourceMappingURL=schemas.js.map
